import React from "react";
import LoginForm from "./loginForm";
import SignupForm from "./signupForm";

export default function formSection(props: any) {
  return (
    <div>
      {props.isLogin === 1 ? <LoginForm refresh={props.refresh} /> : null}
      {props.isSignup === 1 ? (
        <SignupForm
          isBackButtonDisplay={props.isBackButtonDisplay}
          backButtonClick={props.backButtonClick}
        />
      ) : null}
    </div>
  );
}
